import { useCallback, useEffect, useMemo } from "react";
import { Form } from "antd";
import _ from "lodash";

import SearchWidget from ".";

const SearchForm = ({ data, searchProps = {}, onSearch = () => {} }) => {
  const [form] = Form.useForm();

  const changeHandler = _.debounce(
    useCallback(
      (values) => {
        onSearch(values?.search || "");
      },
      [onSearch]
    ),
    1000
  );

  const initialValues = useMemo(
    () => ({
      search: data?.search || "",
    }),
    [data]
  );

  useEffect(() => {
    if (data?.search && typeof data?.search === "string") {
      form.setFieldsValue({ search: data.search });
    }
  }, [form, data]);

  return (
    <Form
      form={form}
      name="search_form"
      layout="vertical"
      initialValues={initialValues}
      onValuesChange={changeHandler}
    >
      <Form.Item name="search" noStyle>
        <SearchWidget {...searchProps} />
      </Form.Item>
    </Form>
  );
};

export default SearchForm;
